// Generated by Melange

import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as JsxRuntime from "react/jsx-runtime";

function AdminIdentitiesSubHeader(Props) {
  let currentRoute = Props.currentRoute;
  let identityId = Props.identityId;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Buhta_cabinet__Link.make, {
        route: {
          TAG: /* Admin */ 7,
          _0: {
            TAG: /* Identities */ 2,
            _0: {
              TAG: /* Item */ 0,
              _0: identityId,
              _1: /* General */ 0
            }
          }
        },
        children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
          className: Caml_obj.caml_equal(currentRoute, {
            TAG: /* Admin */ 7,
            _0: {
              TAG: /* Identities */ 2,
              _0: {
                TAG: /* Item */ 0,
                _0: identityId,
                _1: /* General */ 0
              }
            }
          }) ? "text-white" : "text-gray-medium",
          children: "Общая информация"
        })
      }),
      JsxRuntime.jsx(Buhta_cabinet__Link.make, {
        route: {
          TAG: /* Admin */ 7,
          _0: {
            TAG: /* Identities */ 2,
            _0: {
              TAG: /* Item */ 0,
              _0: identityId,
              _1: /* Security */ 1
            }
          }
        },
        children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
          className: Caml_obj.caml_equal(currentRoute, {
            TAG: /* Admin */ 7,
            _0: {
              TAG: /* Identities */ 2,
              _0: {
                TAG: /* Item */ 0,
                _0: identityId,
                _1: /* Security */ 1
              }
            }
          }) ? "text-white" : "text-gray-medium",
          children: "Безопасность"
        })
      }),
      JsxRuntime.jsx(Buhta_cabinet__Link.make, {
        route: {
          TAG: /* Admin */ 7,
          _0: {
            TAG: /* Identities */ 2,
            _0: {
              TAG: /* Item */ 0,
              _0: identityId,
              _1: /* API */ 2
            }
          }
        },
        children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
          className: Caml_obj.caml_equal(currentRoute, {
            TAG: /* Admin */ 7,
            _0: {
              TAG: /* Identities */ 2,
              _0: {
                TAG: /* Item */ 0,
                _0: identityId,
                _1: /* API */ 2
              }
            }
          }) ? "text-white" : "text-gray-medium",
          children: "Ключи API"
        })
      })
    ],
    className: "flex justify-between bg-black px-4 py-3"
  });
}

const make = AdminIdentitiesSubHeader;

export {
  make,
}
/* Buhta_cabinet__Link Not a pure module */
